<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pb-2 globalborder-btm-header">
        <span class="col-auto">
          <h2 class="mb-0">
            Email
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>
      <div class="col-12 adduser-container-hgt mt-2">
        <div class="row">
          <div class="">
            <jni-display-pdf-frame
              *ngIf="!poEmailScreenStatus"
              [parent]="poEmailForm"
              [templatesList]="poTemplates"
              [poNumber]="poNumberParams"
              (emailSelectionEvent)="emailSelection()">
            </jni-display-pdf-frame>
          </div>
          <div class="col-12 mb-3">
            <div class="gray-bg-rounded">
              <jni-po-email-header
                *ngIf="poEmailScreenStatus"
                [parent]="poEmailForm"
                [templates]="poTemplates"
                [formErrors]="formErrors"
                [validationMessages]="validationMessages"
                [emailButtonStatus]="emailButtonStatus"
                (fetchVendorInformation)="
                  getVendorInformationForPOEmail($event)
                "
                (templateSelectedEvent)="templatedSelected($event)"
                (logValidationErrorsEvent)="logValidationErrors()"
                (sendEmailEvent)="sendEmailEvent()"></jni-po-email-header>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 mb-3">
            <div class="gray-bg-rounded">
              <jni-po-email-recipients
                *ngIf="poEmailScreenStatus"
                [recipientsList]="recipientsList"
                (recipientsDeletedEvent)="recipientsDeleted($event)"
                (recipientsAddEvent)="
                  recipientsAdd()
                "></jni-po-email-recipients>
            </div>
          </div>
          <div class="col-6 mb-3">
            <div class="gray-bg-rounded">
              <jni-po-email-contacts
                *ngIf="poEmailScreenStatus"
                [contactsList]="vendorContacts"
                (addCCEvent)="addCC($event)"
                (addTOEvent)="addTO($event)"></jni-po-email-contacts>
            </div>
          </div>
        </div>
        <div class="col-12 mb-3">
          <div class="gray-bg-rounded">
            <jni-po-email-attachments
              *ngIf="poEmailScreenStatus"
              (attachmentFileArrayEvent)="getAttachmentFileArray($event)"
              (TotalFileSizeEvent)="getTotalFileSize($event)"
              (attachmentFileArrayUrlEvent)="attachmentFileUrlArray($event)">
            </jni-po-email-attachments>
          </div>
        </div>

        <div class="row" [hidden]="!poEmailScreenStatus">
          <jni-editor
            [displaySendButton]="displaySendButton"
            #emailComponent
            (sendEmail)="sendEmail($event)"
            [htmlBody]="templateBody"></jni-editor>
        </div>
      </div>
    </p-card>
  </div>
</div>
